<template>
	<div class="row full-height">
		<div class="col-12">
			<vue-plyr ref="plyr" class="video" :options="options">
				<div data-plyr-provider="youtube" :data-plyr-embed-id="`${source}`"></div>
			</vue-plyr>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'WebinarYouTubePlayer',

	props: ['activity'],

	data() {
		return {
			options: {
				autoplay: true,
			},
			source: null,
		}
	},

	methods: {
		youtubeParser(url) {
			let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
			let match = url.match(regExp)
			this.source = match && match[7].length == 11 ? match[7] : false
		},
	},

	created() {
		this.youtubeParser(this.activity.embed)
		this.$emit('startWebinar', this.activity)
	},

	beforeUnmount() {
		this.$mitt.emit('setUserOfflineFirebase', this.activity)
	},
}
</script>

<style></style>
